<!-- 通用查询计费接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody:{
                "parkCode":"2KNTYVWC",
                "carType":1,
                "startTime":"2018-01-01 00:00:00",
                "endTime":"2018-01-01 10:00:00",
            },
            responseCode: {
                "status": 1,
                "resultCode": 0,
                "message": "业务成功",
                "data": {
                    "totalAmount": 10.00
                  // ,
                  //   "disAmount": 0,
                  //   "payAmount": 10.00,
                  //   "traderCouponList": []
                }
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台按时间获取停车费用接口，一般用于未来未知时间段内停车费用计算",
                t_url: this.commonUrls.test+"commonGetParkFee",
                p_url: this.commonUrls.prod+"commonGetParkFee",
                precondition: "VEMS 2.13及以上版本支持",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carType', info2: '是', info3: 'String', info4: '车辆类型,0未知或不区分，1小车，2大车，3超大车，4中型车' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '开始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间,yyyy-MM-dd HH:mm:ss' },
                        { info1: 'chargeGroup', info2: '否', info3: 'String', info4: '计费规则编号，默认0（只支持云车场）' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌编号,目前无实际意义，仅作跟踪使用' },
                        { info1: 'cardNumber', info2: '否', info3: 'String', info4: '卡编号,目前无实际意义，仅作跟踪使用' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'totalAmount', info2: '是', info3: 'Decimal', info4: '停车费用' },
                        // { info1: 'disAmount', info2: '是', info3: 'Decimal', info4: '优惠费用' },
                        // { info1: 'payAmount', info2: '是', info3: 'Decimal', info4: '应收费用' },
                        // { info1: 'traderCouponList', info2: '否', info3: 'String', info4: '商家券列表' }
                        ]
                }
                // ,{
                //     titleName: 'traderCouponList：查费时的商家券',
                //     tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                //     td: [
                //         { info1: 'traderCouponGrantSn', info2: '是', info3: 'String', info4: '对应商家优惠券编号' },
                //         { info1: 'traderCouponValue', info2: '是', info3: 'Decimal', info4: '抵扣金额' },
                //         { info1: 'isValid', info2: '是', info3: 'boolean', info4: '是否有效（曾经已被使用则是无效券）' }
                //         ]
                // }
                ],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/commonGetParkFee.vue